import React from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import { FaCheckCircle } from 'react-icons/fa';
import { useMenuContext } from '../context/MenuContext';
import ImageViewerButton from '../../layout/ImageViewerButton';

export const BasicInfoTab = () => {
  const { 
    itemFormData, 
    setItemFormData, 
    categories, 
    sharedModGroups, 
    selectedSharedGroups, 
    setSelectedSharedGroups,
    productImageFile,
    setProductImageFile,
    productImagePreview,
    setProductImagePreview
  } = useMenuContext();

  const toggleSharedGroup = (groupId) => {
    if (selectedSharedGroups.includes(groupId)) {
      setSelectedSharedGroups(selectedSharedGroups.filter(id => id !== groupId));
    } else {
      setSelectedSharedGroups([...selectedSharedGroups, groupId]);
    }
  };
  return (
    <>
      <div className="mb-4">
        <Form.Group className="mb-3">
          <Form.Label className="fw-bold text-secondary">Menu Name</Form.Label>
          <Form.Control type="text" required value={itemFormData.name} onChange={(e) => setItemFormData({...itemFormData, name: e.target.value})} placeholder="e.g. Iced Latte" />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label className="fw-bold text-secondary">Category</Form.Label>
          <Form.Select value={itemFormData.category_id} onChange={(e) => setItemFormData({...itemFormData, category_id: e.target.value})}>
            <option value="">-- No Category --</option>
            {categories.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
          </Form.Select>
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label className="fw-bold text-secondary">Base Price (THB)</Form.Label>
          <Form.Control type="number" step="0.01" min="0" required value={itemFormData.base_price} onChange={(e) => setItemFormData({...itemFormData, base_price: e.target.value})} />
        </Form.Group>
        
        <Form.Group className="mb-3">
          <Form.Label className="fw-bold text-secondary">Product Image (รูปภาพสินค้า)</Form.Label>
          <div>
            {productImagePreview ? (
              <ImageViewerButton 
                imageUrl={productImagePreview}
                onUpdate={(file) => {
                  setProductImageFile(file);
                  setProductImagePreview(URL.createObjectURL(file));
                }}
                onDelete={() => {
                  setProductImageFile(null);
                  setProductImagePreview("");
                  setItemFormData({ ...itemFormData, image_url: null });
                }}
                buttonText="ดูรูปสินค้า"
              />
            ) : (
              <Form.Label className="btn btn-outline-secondary btn-sm m-0" style={{ cursor: 'pointer' }}>
                เพิ่มรูป
                <Form.Control 
                  type="file" 
                  accept="image/*" 
                  style={{ display: 'none' }} 
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                      setProductImageFile(file);
                      setProductImagePreview(URL.createObjectURL(file));
                    }
                  }} 
                />
              </Form.Label>
            )}
          </div>
        </Form.Group>
        
        <Form.Group className="mb-3">
          <Form.Check 
            type="switch"
            id="item-active-switch"
            label={<span className="fw-bold text-secondary">Active (เปิดขาย)</span>}
            checked={itemFormData.is_active}
            onChange={(e) => setItemFormData({...itemFormData, is_active: e.target.checked})}
          />
        </Form.Group>
      </div>
      
      <hr className="my-4 text-muted" />

      <div className="py-2">
        <h6 className="fw-bold text-secondary mb-3">Shared Add-ons</h6>
        <p className="text-muted small mb-3">Click to toggle the shared modifier groups that apply to this menu.</p>
        <Row className="g-3">
          {sharedModGroups.map(group => {
            const isSelected = selectedSharedGroups.includes(group.id);
            return (
              <Col xs={12} sm={6} md={4} lg={3} key={group.id}>
                <div 
                  onClick={() => toggleSharedGroup(group.id)}
                  className={`p-3 border rounded text-center cursor-pointer transition-all ${isSelected ? 'bg-primary text-white border-primary shadow-sm' : 'bg-white text-secondary'}`}
                  style={{ cursor: "pointer", transition: "0.2s" }}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <span className="fw-bold">{group.name}</span>
                    {isSelected && <FaCheckCircle />}
                  </div>
                  <div className={`small mt-1 ${isSelected ? 'text-white-50' : 'text-muted'}`}>
                    {group.is_required ? "Required" : "Optional"} | Max: {group.max_choices}
                  </div>
                </div>
              </Col>
            );
          })}
        </Row>
        {sharedModGroups.length === 0 && <div className="text-center py-4 text-muted border rounded">No shared modifiers available.</div>}
      </div>
    </>
  );
};
